import React from 'react';

declare global {
  const WP_DEVELOP_MODE: boolean;
}

const isEnabled = WP_DEVELOP_MODE;

/**
 * Indica si el debugDispatcher fue activado, lo que en muchos casos indica que
 * estamos en ambiente de desarrollo
 */
export function isDebugDispatcherEnabled() {
  return isEnabled;
}

type TWindowDDispatch = (action: string, ...parameters: unknown[]) => void;
export type TDispatchCallback = (parameters: unknown[]) => unknown;
interface IStoredCallback {
  (parameters: unknown[]): unknown;
  help: () => void;
}

export const debugDispatcher = new (class DDispatcher {
  callbacks: Record<string, IStoredCallback[]> = {};

  actions: Record<string, () => void> = {
    shout: () => {
      console.log(Object.keys(this.callbacks));
    },
  };

  on(
    action: string,
    cb: TDispatchCallback,
    help: string | React.ReactNode,
    onlyDevelop = false,
  ) {
    if (!isEnabled && onlyDevelop) return () => {};

    if (Object.keys(this.actions).includes(action))
      throw new Error(
        `The action ${action} is a reserved word for the dispatcher.`,
      );
    if (!this.callbacks[action]) this.callbacks[action] = [];
    const actionMethod = Object.assign(cb, {
      help: () => {
        if (typeof help === 'string') console.info(help);
      },
    });
    this.callbacks[action].push(actionMethod);
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    this[action] = Object.assign(
      (...props: unknown[]) => {
        this.emit(action, ...props);
      },
      {
        help: () => {
          if (typeof help === 'string') console.info(help);
        },
      },
    );
    return () => {
      this.off(action, cb);
    };

    // return () => {};
  }

  off(action: string, cb: TDispatchCallback) {
    this.callbacks[action] = this.callbacks[action].filter((current) => {
      return current !== cb;
    });
  }

  emit: TWindowDDispatch = (action, ...parameters) => {
    try {
      if (this.actions[action]) this.actions[action]();
      else {
        if ((this.callbacks[action] ?? []).length === 1)
          return this.callbacks[action]?.[0]?.(parameters);

        (this.callbacks[action] ?? []).forEach((cb) => {
          return cb(parameters);
        });
      }
      return null;
    } catch (e) {
      console.error('DD', e);
    }
  };
})();

declare global {
  interface Window {
    adt: typeof debugDispatcher;
    dd: typeof debugDispatcher & Record<string, () => unknown>;
  }
}

window.dd = debugDispatcher as typeof debugDispatcher &
  Record<string, () => unknown>;
window.adt = debugDispatcher;
